import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./index.vue?vue&type=style&index=0&id=644301dc&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/var/jenkins_home/workspace/ringg_deliveryhub-app_production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__